import { render, staticRenderFns } from "./HistoryFunctions.vue?vue&type=template&id=ef52dcde&scoped=true&"
import script from "./HistoryFunctions.vue?vue&type=script&lang=js&"
export * from "./HistoryFunctions.vue?vue&type=script&lang=js&"
import style0 from "./HistoryFunctions.vue?vue&type=style&index=0&id=ef52dcde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef52dcde",
  null
  
)

export default component.exports